<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="20">
          <el-form :inline="true">
            <el-form-item>
              <el-button type="primary" @click="formVisible = true">添加账号</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table :data="records" border>
        <el-table-column label="姓名" prop="name"></el-table-column>
        <el-table-column label="角色" prop="role">
          <template slot-scope="scope">
            {{ scope.row.role.name }}
          </template>
        </el-table-column>
        <el-table-column label="账号" prop="username"></el-table-column>
        <el-table-column label="手机号" prop="mobile"></el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="info" v-else>禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="created_at"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">编辑</el-button>
            <el-button type="danger" @click="del">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog
      :title="`${modalTit}账号`"
      :visible.sync="formVisible"
      width="600px">
      <el-form ref="formInline" :model="formData" :rules="ruleValidate" label-width="100px" @submit.native.prevent>
        <el-form-item label="账号" prop="username">
          <el-input v-model="formData.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="formData.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password_confirm">
          <el-input type="password" v-model="formData.password_confirm"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="formData.mobile"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role_id">
          <el-select v-model="formData.role_id" style="width: 100%;">
            <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onSave">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import request from '@/utils/request'
import { Notification } from 'element-ui'
export default {
  name: 'Users',
  data () {
    return {
      roles: [],
      records: [],
      formData: {
        name: '',
        username: '',
        password: '',
        mobile: '',
        email: '',
        role_id: ''
      },
      ruleValidate: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入账号姓名', trigger: 'blur' }]
      },
      formVisible: false,
      modalTit: ''
    }
  },
  mounted () {
    this.getRoles()
  },
  methods: {
    getRoles() {
      request.get('roles').then(res=>{
        this.roles = res.data
        this.getList()
      })
    },
    getList () {
      const loading = this.$loading({
        lock: true,
        text: '数据加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      request.get('admins', this.filterData).then(res => {
        this.records = res.data
        loading.close()
      })
    },
    add () {
      this.modalTit = '添加'
      this.formVisible = true
    },
    edit (row) {
      this.modalTit = '编辑'
      const loading = this.$loading({
        lock: true,
        text: '数据加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      request.get(`admins/${row.id}`).then(res => {
        this.formData = res.data
        loading.close()
        this.formVisible = true
      })
    },
    onCancel() {
      this.formVisible = false
      this.formData = {}
    },
    onSave () {
      request.post('admins', this.formData).then(() => {
        this.getList()
        this.formVisible = false
        this.formData = {}
      }).catch(err=>{
        Notification({
          title: '提示',
          message: err
        })
      })
    },
    del () {
      this.$confirm('确定删除此项吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
</style>
